/**
 * @generated SignedSource<<67bd3b36f7e1e00c62bb3a4d33a86572>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type image_reportsOverviewPage_ReportCardImage$data = {
  readonly imageUrl: string | null | undefined;
  readonly isNotApplicableReason?: string | null | undefined;
  readonly key: string;
  readonly name: string;
  readonly " $fragmentType": "image_reportsOverviewPage_ReportCardImage";
};
export type image_reportsOverviewPage_ReportCardImage$key = {
  readonly " $data"?: image_reportsOverviewPage_ReportCardImage$data;
  readonly " $fragmentSpreads": FragmentRefs<"image_reportsOverviewPage_ReportCardImage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMigrateTMPReportsOverviewEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "image_reportsOverviewPage_ReportCardImage",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "key"
      },
      "action": "THROW",
      "path": "key"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "name"
      },
      "action": "THROW",
      "path": "name"
    },
    {
      "condition": "isMigrateTMPReportsOverviewEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isNotApplicableReason"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "imageUrl"
    }
  ],
  "type": "JiraReport"
};

(node as any).hash = "275b49862af0e5654c7c344f28881698";

export default node;
